import { Skeleton } from '../../shadcn';

function GameInfoLoading() {
  return (
    <>
      <div className="ll-grid-container py-3 bg-container-base">
        <div className="flex items-center gap-2 ll-container-inner">
          <Skeleton className="size-6 rounded" />
          <Skeleton className="h-6 w-48" />
        </div>
        <div className="hidden md:flex items-center justify-between ll-container-inner pl-8 mt-2">
          <Skeleton className="h-4 w-120" />
        </div>
      </div>

      <div className="ll-container-full md:hidden px-6 mb-6 mt-4">
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-3/4" />
      </div>

      <div className="ll-narrow-grid-container">
        <div className="ll-container-inner">
          <Skeleton className="w-full aspect-[16/9] rounded-lg md:mt-10 mb-4" />

          <div className="bg-container py-2 px-4 hidden md:flex items-center justify-between rounded-md mb-4">
            <Skeleton className="size-10 rounded-full" />
            <Skeleton className="h-10 w-24 rounded-md" />
          </div>

          <div className="grid grid-cols-2 gap-4 mb-8">
            <div className="space-y-2">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-5 w-20" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-5 w-16" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-18" />
              <Skeleton className="h-5 w-24" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-18" />
              <Skeleton className="h-5 w-24" />
            </div>
          </div>

          <Skeleton className="h-5 w-32 mb-4" />

          <div className="space-y-3 mb-6">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-11/12" />
            <Skeleton className="h-4 w-4/5" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
        </div>
      </div>

      <div className="md:hidden sticky bottom-0 shadow-top-m rounded-t-lg px-5 flex items-center justify-between gap-6 py-4 bg-container-base">
        <Skeleton className="h-10 flex-1 rounded-md" />
        <Skeleton className="size-10 rounded-full" />
      </div>
    </>
  );
}

export { GameInfoLoading };
